import { defineComponent } from "vue";
import { Flow } from "@mv/flow-shared-utils/types/flow";
import SdkFormsSearch from "@/components/sdk-forms/sdk-forms-search/sdk-forms-search.vue";
import { checkCreationLimit, getPaginatedProcessList } from "@/store/flow/actions";

export default defineComponent({
  name: "sdk-flow-category",
  components: {
    "sdk-flow-definition-card": () => import("@/components/sdk-flow-definition-card/sdk-flow-definition-card.vue"),
    SdkFormsSearch,
  },
  data() {
    return {
      processDefinitions: [] as Flow.Process.Definition.definition[],
      list: [] as Flow.Process.Definition.definition[],
      processLimitReached: {
        limitNumberProcess: 0,
        numberProcessLimitReached: false,
      },
      loading: false,
      hasProcessInCategory: true,
      paginationConfig: {
        currentPage: 1,
        totalPages: 0,
      },
      userQuery: "",
    };
  },
  computed: {
    filteredList(): Flow.Process.Definition.definition[] {
      return this.processDefinitions;
    },
    reachedLimitHint(): string {
      return `${this.$t("flow.category.buttons.reachedProcessLimitHint")} ${this.processLimitReached.limitNumberProcess} ${this.$t(
        "flow.category.buttons.process"
      )}`;
    },
  },
  methods: {
    startCreation() {
      this.$router.push({ name: "flow-builder" });
    },
    filterResult(value: string) {
      this.userQuery = value;
      this.paginationConfig.currentPage = 1;
      this.getCategories();
    },
    async checkProcessCreateLimit() {
      this.loading = true;
      await this.$dispatch(checkCreationLimit)([])
        .then((res: any) => {
          this.processLimitReached.numberProcessLimitReached = res.numberProcessLimitReached;
          this.processLimitReached.limitNumberProcess = res.limitNumberProcess;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getCategories() {
      this.loading = true;
      await this.$dispatch(getPaginatedProcessList)([this.$route.params.categoryId, this.paginationConfig.currentPage, this.userQuery])
        .then((res: any) => {
          this.paginationConfig.totalPages = res.pagination.totalPages;
          this.processDefinitions = res.data;

          if (!this.processDefinitions.length) {
            this.hasProcessInCategory = false;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  async mounted() {
    await this.checkProcessCreateLimit();
    await this.getCategories();
  },
});
